import { useTranslation } from "@outschool/localization";
import { Label } from "@outschool/ui-legacy-component-library";
import React from "react";

import { SectionStatus, isCanceled, isPublished } from "../../shared/Section";

const ActivityPrivacyStatusLabel = ({
  section,
}: {
  section: SectionStatus & { is_self_paced?: boolean };
}) => {
  const { t } = useTranslation(
    "client\\components\\ActivityPrivacyStatusLabel",
  );

  // don't show label for self-paced sections
  if (!!section.is_self_paced) {
    return <Label>{t("Self-Paced")}</Label>;
  }

  if (isCanceled(section)) {
    return (
      <Label color="warning" textColor="text">
        {t("Canceled")}
      </Label>
    );
  }
  if (isPublished(section)) {
    return <Label>{t("Public")}</Label>;
  }
  return (
    <Label color="warning" textColor="text">
      {t("Private")}
    </Label>
  );
};

export default ActivityPrivacyStatusLabel;
